import { gql } from '@apollo/client';
import { useMutationCompat as useMutation } from '../../lib/apollo/mutationCompat';
import {getAuthStore} from './sessionStore';
import {getEnv} from "../../getEnv";
import {logger} from '../../lib/logger';

const LOG = gql`
  mutation ($event: EventInput) {
    LogReport(event: $event)
  }
`;

export function useReportingMutations() {
  const [log] = useMutation(LOG);
  return { log };
}

const getGraphqlBase = () => {
  const endpoint = getEnv().graphql_endpoint;
  return endpoint.endsWith('/graphql') ? endpoint.slice(0, -8) : endpoint;
};

export async function logSignoutManually(reason) {
  const { access_token } = getAuthStore();
  try {
    const response = await fetch(getGraphqlBase(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'authorization': `Bearer ${access_token}`
      },
      body: JSON.stringify({
        query: `
          mutation ($event: EventInput) {
            LogReport(event: $event)
          }
        `,
        variables: {
          event: {
            name: "portalLogout",
            reason: reason
          }
        }
      }),
    });
    return await response.json();
  } catch (err) {
    logger.error('SIEM log failed during logout');
  }
}

export async function logLoginManually(accessToken, tokenExpiryIso) {
  try {
    await fetch(getGraphqlBase(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'authorization': `Bearer ${accessToken}`
      },
      body: JSON.stringify({
        query: `
          mutation ($event: EventInput) {
            LogReport(event: $event)
          }
        `,
        variables: {
          event: {
            name: "portalLogin",
            field: "tokenExpiryTime",
            value: tokenExpiryIso
          }
        }
      }),
    });
  } catch (err) {
    logger.error('Failed to log portal login event');
  }
}
